




















import Vue from 'vue';

export default Vue.extend({
    props: ['menuData'],
    data() {
        return {};
    },
    methods: {
        GAcode(el: string) {
            if (typeof window.ActionAnalysisV2 !== 'undefined' && typeof el !== 'undefined') {
                window.ActionAnalysisV2.actClk(el);
            }
        }
    }
});
